import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { ShopService } from '../service';
import {
	createShopModule,
	createShopModuleFailure,
	createShopModuleSuccess,
	createTag,
	createTagFailure,
	createTagSuccess,
	deleteShopModule,
	deleteShopModuleFailure,
	deleteShopModuleSuccess,
	deleteTag,
	deleteTagFailure,
	deleteTagSuccess,
	getNewShopModuleOrder,
	getShopModuleToUpdate,
	getShopModuleToUpdateFailure,
	getShopModuleToUpdateSuccess,
	getShopModules,
	getShopModulesFailure,
	getShopModulesSuccess,
	searchShopModules,
	searchTags,
	setNewShopModuleOrder,
	setSearchShopModulesResult,
	setSearchTagsResult,
	updateShopModule,
	updateShopModuleFailure,
	updateShopModuleSuccess,
	updateTag,
	updateTagFailure,
	updateTagSuccess,
} from './slice';

function* getShopModulesHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		const data = yield service.getShopModules(action.payload);
		yield put(getShopModulesSuccess(data));
	} catch (e) {
		yield put(getShopModulesFailure(e));
		console.error(e);
	}
}

function* searchShopModulesHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		const data = yield service.searchShopModules(action.payload.searchKey);
		yield put(setSearchShopModulesResult({ shopModules: data }));
	} catch (e) {
		console.error(e);
	}
}

function* deleteShopModuleHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		yield service.deleteShopModule(action.payload.shopModuleId);

		yield put(deleteShopModuleSuccess({}));
		toast('Souq module deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteShopModuleFailure(e));
		console.error(e);
	}
}

function* createShopModuleHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		yield service.createShopModule(action.payload.shopModule);
		yield put(createShopModuleSuccess({}));
		toast('Souq module created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createShopModuleFailure({}));
	}
}

function* getShopModuleToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		const data = yield service.getShopModule(action.payload.moduleId);
		yield put(
			getShopModuleToUpdateSuccess({
				shopModule: data,
			}),
		);
	} catch (e) {
		yield put(getShopModuleToUpdateFailure({}));
	}
}

function* updateShopModuleHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		yield service.updateShopModule(action.payload.shopModule);
		yield put(updateShopModuleSuccess({}));
		toast('Souq module updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateShopModuleFailure({}));
	}
}

function* getNewShopModuleOrderHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new ShopService(
			globalApplicationContext,
		);

		const data = yield regionsConfigurationService.getNewShopModuleOrder();
		console.log({ data });
		yield put(setNewShopModuleOrder(data));
	} catch (e) {
		yield put(setNewShopModuleOrder({ order: 1 }));
	}
}

function* searchTagsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		const data = yield service.searchTags(action.payload.searchKey);
		yield put(setSearchTagsResult({ tags: data }));
	} catch (e) {
		console.error(e);
	}
}

function* createTagHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		const data = yield service.createTag(action.payload.tag);
		yield put(createTagSuccess({ data }));
		toast('Tag created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createTagFailure({}));
	}
}

function* updateTagHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		const data = yield service.updateTag(action.payload.tag);
		yield put(updateTagSuccess({ data }));
		toast('Tag updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateTagFailure({}));
	}
}

function* deleteTagHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new ShopService(globalApplicationContext);
		const data = yield service.deleteTag(action.payload.tagId);
		yield put(deleteTagSuccess({ data }));
		toast('Tag deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteTagFailure({}));
	}
}

export function* shopSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getShopModules, getShopModulesHandler),
		takeEvery(searchShopModules, searchShopModulesHandler),
		takeEvery(deleteShopModule, deleteShopModuleHandler),
		takeEvery(createShopModule, createShopModuleHandler),
		takeEvery(getShopModuleToUpdate, getShopModuleToUpdateHandler),
		takeEvery(updateShopModule, updateShopModuleHandler),
		takeEvery(getNewShopModuleOrder, getNewShopModuleOrderHandler),

		takeEvery(searchTags, searchTagsHandler),
		takeEvery(createTag, createTagHandler),
		takeEvery(updateTag, updateTagHandler),

		takeEvery(deleteTag, deleteTagHandler),
	]);
}
